'use es6';

export default (({
  apiClient
}) => {
  return apiClient.get(`users/v1/app/user`);
});